import { IAction, INotificationAction } from '../../models/action/core';
import { actions } from '../constants/core';
import { Dispatch } from 'react';
import { Notification } from '../../components/notification/main';

const NotificationMiddleware = (store: any) => {
    return (next: Dispatch<IAction>) => {
        return (action: IAction) => {
            const result = next(action);
            if (action.type === actions.CORE_NOTIFICATION) {
                const notification: INotificationAction = (action as INotificationAction);
                const timeout: number = notification.timeout || 3000;
                const callback = notification.onClick || null;
                if (notification.notificationType) {
                    Notification.setNotification(notification.notificationType, notification.text, notification.position, notification.timeOut);
                }
            }
            return result;
        };
    };
};

export default NotificationMiddleware;
